import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { isElement, isKey } from '../../utils'

import * as themes from '../../styles/themes'
import * as lightThemes from '../../styles/light-themes'

const styles = {
  badge: {
    fontWeight: 600,
    fontStyle: 'normal',
    display: 'inline-block',
    flexShrink: 0,
    paddingLeft: '8px',
    paddingRight: '8px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    verticalAlign: 'middle',
  },
  nested: {
    marginTop: '-15px',
    marginRight: '2px',
    ':last-child': {
      marginRight: '-20px',
    },
  },
  group: {
    display: 'inline-block',

    '>:not(:last-child)': {
      marginRight: '-20px',
      paddingRight: '25px',
    },
  },
  small: {
    height: '20px',
    minWidth: '20px',
    lineHeight: '20px',
    borderRadius: '10px',
    fontSize: '11px',
  },
  large: {
    height: '40px',
    minWidth: '40px',
    lineHeight: '40px',
    borderRadius: '20px',
    fontSize: '16px',
  },
}

interface IBadgeProps {
  children: React.ReactNode
  theme?: themes.UiTheme
  size?: 'small' | 'large'
  style?: Rule
  light?: boolean
  nested?: boolean
}

export class Badge extends React.Component<IBadgeProps> {
  static displayName = 'Badge'
  static propTypes = {
    children: PropTypes.node,
    theme: PropTypes.oneOf(Object.keys(themes)),
    size: PropTypes.oneOf(['small', 'large']),
    style: PropTypes.object,
    light: PropTypes.bool,
    nested: PropTypes.bool,
  }
  static defaultProps = {
    theme: 'light',
    light: false,
    size: 'small',
  }
  static THEMES = Object.keys(themes)
  static SIZES = ['small', 'large']

  render() {
    const { children, theme, light, style, nested, size, ...additional } = this.props
    const themeMap = light ? lightThemes : themes
    return (
      <i
        role="img"
        {...css([
          styles.badge,
          nested && styles.nested,
          (isKey(themeMap, theme) && themeMap[theme]) || themes.dark,
          isKey(styles, size) && styles[size],
          style,
        ])}
        {...additional}
      >
        {React.Children.map(children, child =>
          child && isElement(child) && child.type === Badge ? React.cloneElement(child, { nested: true }) : child
        )}
      </i>
    )
  }
}

interface IBadgeGroupProps {
  children: React.ReactNode
}

export function BadgeGroup({ children }: IBadgeGroupProps) {
  return <div {...css(styles.group)}>{children}</div>
}

BadgeGroup.propTypes = {
  children: PropTypes.node,
}
